<template>
  <smd-one-col-layout>
    <div class="freestylelibre-confirmation">
      <div class="freestylelibre-confirmation__img-container">
        <img src="~@/assets/images//program/freestylelibre/img053.png" alt="Thank you for signing up!">
      </div>

      <div class="freestylelibre-confirmation__header">
        <text-string label-id="txt1455"/>
        <text-string label-id="txt1456"/>
        <div class="divider"></div>
      </div>

      <div class="freestylelibre-confirmation__patient-details smd-form">
        <text-string label-id="txt774"/>

        <div class="smd-form__row m-b-10">
          <div class="smd-form__col">
            <label normal for="firstname">{{$options.mapFieldNames.firstname}}</label>
            {{firstname}}
          </div>
          <div class="smd-form__col">
            <label normal for="middlename">{{$options.mapFieldNames.middlename}}</label>
            {{middlename}}
          </div>
        </div>

        <div class="smd-form__row m-b-10">
          <div class="smd-form__col">
            <label normal for="lastname">{{$options.mapFieldNames.lastname}}</label>
            {{lastname}}
          </div>
        </div>

        <div class="smd-form__row m-b-10">
          <div class="smd-form__col">
            <label normal for="dateofbirth">{{$options.mapFieldNames.birthdate}}</label>
            {{birthdate | formatBirthDate}}
          </div>
          <div class="smd-form__col">
            <label normal for="sex">{{$options.mapFieldNames.gender}}</label>
            {{$options.genderOptions[gender].label}}
          </div>
        </div>

        <div class="smd-form__row m-b-10">
          <div class="smd-form__col">
            <label normal for="mobilenumber">{{$options.mapFieldNames.mobilenumber}}</label>
            {{mobilenumber}}
          </div>
        </div>

        <div class="smd-form__row m-b-10">
          <div class="smd-form__col">
            <label normal for="email">{{$options.mapFieldNames.email}}</label>
            {{ email || '-' }}
          </div>
        </div>

        <div v-for="(q, index) in programQuestions"
             :key="index"
             class="smd-form__row m-b-10">
          <div class="smd-form__col">
            <label normal>{{q.question}}</label>
            {{ displayAnswer(q) }}
          </div>
        </div>
      </div>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import moment from 'moment';
  import {mapFields} from 'vuex-map-fields';
  import {mapGetters} from 'vuex';
  import {genderOptions} from '@/reference/forms';

  import {
    GETTER_PROGRAM_QUESTIONS,
  } from '@/store/types';

  export default {
    name: 'freestylelibre-confirmation',
    filters: {
      formatBirthDate(date) {
        return moment(date).format('MMM D, YYYY');
      },
    },
    computed: {
      ...mapFields('program', {
        firstname: 'respondent.firstname',
        middlename: 'respondent.middlename',
        lastname: 'respondent.lastname',
        birthdate: 'respondent.birthdate',
        gender: 'respondent.gender',
        mobilenumber: 'respondent.mobilenumber',
        email: 'respondent.email',
      }),
      ...mapGetters('program', {
        programQuestions: GETTER_PROGRAM_QUESTIONS,
      }),
    },
    methods: {
      displayAnswer(q) {
        return q.question_type === 'radio' ? q.chosen_answer.answer : q.chosen_answer.remarks;
      },
    },
    mapFieldNames: {
      firstname: 'First Name',
      middlename: 'Middle Name',
      lastname: 'Last Name',
      birthdate: 'Date of Birth',
      mobilenumber: 'Mobile No.',
      email: 'Email',
      gender: 'Sex',
    },
    genderOptions,
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .freestylelibre-confirmation {
    @include flex-col();
    gap: space(m-base);

    &__img-container {
      width: 100%;
      min-height: 168px;
      border-radius: 8px;
      overflow: hidden;

      img {
        height: 100%;
        width: 100%;
        display: block;
        object-fit: cover;

        @include responsive(desktop) {
          width: 80%;
          margin: 0 auto;
          border-radius: 8px;
        }
      }
    }

    &__header {
      @include flex-col();
      gap: 10px;

      .apple-store-google-play-container {
        @extend %layout--flex-row-center-xy;
        gap: 20px;
      }

      .divider {
        border-bottom: 1px dashed color(gray-900);
      }
    }

    &__patient-details {

      &> :first-child {
        margin-bottom: 12px;
      }

      label {
        margin-bottom: 5px;
      }
    }
  }
</style>
